export default __webpack_public_path__ + "static/media/Jetmover 1.e04793e8.png";